import { Button, Menu, MenuItem, Popover, Position } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import React from 'react';
import { useHistory } from 'react-router-dom';
import AppToaster from '../../../AppToaster';
import { ContactInfoFragment, useDeleteContactMutation } from '../../../generated/graphql';
import { showErrorMessage } from '../../../helpers/graphql';

type ContactDetailMenuProps = {
  contact: ContactInfoFragment;
  onEdit: () => void;
};

const ContactDetailMenu = ({ contact, onEdit }: ContactDetailMenuProps) => {
  const history = useHistory();
  const [deleteContact, { loading: deleting }] = useDeleteContactMutation({
    variables: {
      id: contact.id,
    },
    onCompleted: () => {
      AppToaster.success(`${contact.display_name}  wurde in den Papierkorb gelegt`);
      history.goBack();
    },
    onError: showErrorMessage,
  });

  return (
    <>
      <Button text="Bearbeiten" icon={IconNames.EDIT} className="ml-2" onClick={onEdit} />
      <Popover
        position={Position.BOTTOM}
        content={
          <Menu>
            <MenuItem text="In den Papierkorb" icon={IconNames.TRASH} onClick={deleteContact as any} />
          </Menu>
        }
      >
        <Button icon={IconNames.MORE} className="ml-2" loading={deleting} />
      </Popover>
    </>
  );
};

export default ContactDetailMenu;
